import React, { useRef, useState } from 'react';
// src/components/PedidosMinimalUpload.tsx
// import ResumoPedidos from 'app/componentes/ResumoPedidos';
import './PedidosMinimalUpload.css';
import { useNavigate } from 'react-router-dom';
import { uploadOrdersMinimal } from 'services/api';
import { BtnVoltarHome } from 'app/componentes/BtnVoltarHome';

export const PedidosMinimalUpload = () => {
    const [file, setFile] = useState<File | null>(null);
    const [rows, setRows] = useState<any[]>([]);
    const [err, setErr] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [inputKey, setInputKey] = useState(0);
    const fileRef = useRef<HTMLInputElement>(null);
    const navigate = useNavigate();

    // const API_BASE =
    //     (import.meta as any).env?.VITE_API_URL?.replace(/\/$/, '') ||
    //     'http://localhost:3001';


    function toNumberLoose(v: any): number {
        if (typeof v === 'number' && isFinite(v)) return v;
        const s = String(v ?? '').trim();
        if (!s) return 0;
        const n = parseFloat(
            s.replace(/[^\d.,-]/g, '').replace(/\.(?=.*\.)/g, '').replace(',', '.')
        );
        return Number.isFinite(n) ? n : 0;
    }

    // Converte possíveis campos do CSV para KG
    function toKgFromRow(r: any): number {
        // gramas (Shopify costuma exportar em 'grams')
        const g =
            toNumberLoose(r.grams) ||
            toNumberLoose(r.peso_g) ||
            toNumberLoose(r.weight_g);
        if (g > 0) return g / 1000;

        // kg (vários nomes possíveis)
        const kg =
            toNumberLoose(r.pesoUnit) ||
            toNumberLoose(r.peso_kg) ||
            toNumberLoose(r.unit_weight) ||
            toNumberLoose(r.weight) ||
            toNumberLoose(r.kg);
        return kg > 0 ? kg : 0;
    }

    async function onUpload() {
        if (!file) return;
        setLoading(true); setErr(null); setRows([]);
        try {

            const data = await uploadOrdersMinimal(file);
            const linhas = data?.linhas || data?.items || data?.rows || [];
            setRows(linhas)
            console.log('Linhas recebidas:', linhas);
        } catch (e: any) {
            console.log('STATUS', e?.response?.status);
            console.log('DATA', e?.response?.data);
            setErr(e.message || 'Falha ao processar');
        } finally {
            setLoading(false);
        }
    }

    function onFileChange(e: React.ChangeEvent<HTMLInputElement>) {
        const f = e.target.files?.[0] || null;
        setFile(f);
        setRows([]);
        setErr(null);
    }

    function clearFile() {
        setFile(null);
        setRows([]);
        setErr(null);
        if (fileRef.current) fileRef.current.value = '';
        setInputKey(k => k + 1);
    }

    // AGRUPA as linhas achatadas (uma por item) em pedidos com itens
    function groupByOrder(flat: any[]) {
        const map = new Map<string, any>();
        for (const r of flat) {
            const id = r.id || 'SEM_ID';
            if (!map.has(id)) {
                map.set(id, {
                    order_id: id,
                    currency: r.moeda ?? null,
                    total: r.valorTotal ?? null,
                    consignee: {
                        name: r.nome_completo ?? null,
                        email: r.email ?? null,
                        phone: r.telefone ?? null,
                        address1: r.rua_e_numero ?? null,
                        address2: r.rua_e_numero2 ?? null,
                        city: r.cidade ?? null,
                        province: r.estado_provincia ?? null,
                        zip: r.cep ?? null,
                        country: r.pais ?? null,
                    },
                    // manteremos 'items' como a propriedade de itens do pedido
                    items: [] as any[],
                });
            }

            map.get(id).items.push({
                title: r.titulo ?? null,
                sku: r.sku ?? null,
                qty: toNumberLoose(r.quantidade ?? 1), // normaliza quantidade
                unit_price: toNumberLoose(r.preco ?? 0),
                // >>> PADRONIZAÇÃO: gravar peso em KG em 'peso_kg'
                peso_kg: toKgFromRow(r),
                hscode: r.hscode ?? null,
                description: r.descricao ?? null,
                category: r.categoria ?? null,
            });
        }
        console.log("#########chegou aqui groupByOrder#########");


        return Array.from(map.values());
    }

    function proceedToResumo() {
        const orders = groupByOrder(rows);
        sessionStorage.setItem('orders:last', JSON.stringify(orders));
        console.log("#########chegou aqui proceedToResumo#########");
        navigate('/dashboard');
    }

    return (
        <div id="orders-minimal" className="om-wrapper">
            <h2 className="om-title">CSV → Campos mínimos (Pedidos)</h2>

            <div className="om-field">
                <label htmlFor="csv-file" className="om-label">
                    CSV de pedidos (Shopify)
                </label>
                <input
                    key={inputKey}
                    id="csv-file"
                    ref={fileRef}
                    className="om-input-file"
                    type="file"
                    accept=".csv"
                    onClick={(e) => { (e.currentTarget as HTMLInputElement).value = ''; }}
                    onChange={onFileChange}
                />
                {file && <div className="om-muted">Selecionado: {file.name}</div>}
            </div>

            <div className="om-actions">
                <button
                    id="btn-upload"
                    className="btn btn-primary"
                    onClick={onUpload}
                    disabled={!file || loading}
                >
                    {loading ? 'Processando…' : 'Enviar'}
                </button>

                {file && (
                    <button type="button" onClick={clearFile} className="btn">
                        Trocar arquivo
                    </button>
                )}

                {/* NOVO: só habilita quando já temos rows */}
                <button
                    id="btn-proceed"
                    className="btn btn-primary"
                    onClick={proceedToResumo}
                    disabled={!rows.length}
                >
                    Prosseguir
                </button>
            </div>

            {rows.length > 0 && (
                <div className="om-muted">Linhas recebidas: {rows.length}</div>
            )}

            {err && <div id="om-error" className="om-error">Erro: {err}</div>}

            {rows.length > 0 && (
                <pre id="om-output" className="om-output">
                    {JSON.stringify(rows, null, 2)}
                </pre>
            )}
            <BtnVoltarHome />
        </div>

    );
};
